import axios from 'axios';

// Set by scripts/with-env.cjs from repo-root .env.<SOCIFY_ENV>
const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
if (apiUrl) {
  axios.defaults.baseURL = apiUrl;
}

export default axios;
